import type { SelectFilterState } from '../../../../../common/constants/filters/select-filter/types';

export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): SelectFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];

		let value: string[] | undefined;

		if (Array.isArray(queryParamValue)) {
			value = queryParamValue.map((param) => decodeURIComponent(param));
		}

		return {
			...initialState,
			value: value || initialState.value,
		};
	};
};
